require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _color = _interopRequireDefault(require("color"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _Text = _interopRequireDefault(require("../Typography/Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _TouchableRipple = _interopRequireDefault(require("../TouchableRipple"));

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Drawer/DrawerItem.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var DrawerItem = function (_React$Component) {
  (0, _inherits2["default"])(DrawerItem, _React$Component);

  function DrawerItem() {
    (0, _classCallCheck2["default"])(this, DrawerItem);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DrawerItem).apply(this, arguments));
  }

  (0, _createClass2["default"])(DrawerItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          label = _this$props.label,
          active = _this$props.active,
          theme = _this$props.theme,
          style = _this$props.style,
          onPress = _this$props.onPress,
          accessibilityLabel = _this$props.accessibilityLabel,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["icon", "label", "active", "theme", "style", "onPress", "accessibilityLabel"]);
      var colors = theme.colors,
          roundness = theme.roundness;
      var backgroundColor = active ? (0, _color["default"])(colors.primary).alpha(0.12).rgb().string() : 'transparent';
      var contentColor = active ? colors.primary : (0, _color["default"])(colors.text).alpha(0.68).rgb().string();
      var font = theme.fonts.medium;
      var labelMargin = icon ? 32 : 0;
      return React.createElement(_reactNative.View, (0, _extends2["default"])({}, rest, {
        style: [styles.container, {
          backgroundColor: backgroundColor,
          borderRadius: roundness
        }, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84
        }
      }), React.createElement(_TouchableRipple["default"], {
        borderless: true,
        delayPressIn: 0,
        onPress: onPress,
        style: {
          borderRadius: roundness
        },
        accessibilityTraits: active ? ['button', 'selected'] : 'button',
        accessibilityComponentType: "button",
        accessibilityRole: "button",
        accessibilityStates: active ? ['selected'] : [],
        accessibilityLabel: accessibilityLabel,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        }
      }, React.createElement(_reactNative.View, {
        style: styles.wrapper,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103
        }
      }, icon ? React.createElement(_Icon["default"], {
        source: icon,
        size: 24,
        color: contentColor,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105
        }
      }) : null, React.createElement(_Text["default"], {
        numberOfLines: 1,
        style: [styles.label, _objectSpread({
          color: contentColor
        }, font, {
          marginLeft: labelMargin
        })],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107
        }
      }, label))));
    }
  }]);
  return DrawerItem;
}(React.Component);

(0, _defineProperty2["default"])(DrawerItem, "displayName", 'Drawer.Item');

var styles = _reactNative.StyleSheet.create({
  container: {
    marginHorizontal: 10,
    marginVertical: 4
  },
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8
  },
  label: {
    marginRight: 32
  }
});

var _default = (0, _theming.withTheme)(DrawerItem);

exports["default"] = _default;